<template>
  <div class="container">
    <mt-header fixed title="报价订单" class="head" >
      <router-link to="/account" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>
    <!--<div class="select">-->
    <!--<mt-navbar v-model="selected">-->
    <!--<mt-tab-item id="-1" data-id="-1" @click.native="filterClick">全部</mt-tab-item>-->
    <!--<mt-tab-item id="3" data-id="3" @click.native="filterClick">执行中</mt-tab-item>-->
    <!--<mt-tab-item id="4" data-id="4" @click.native="filterClick">已完成</mt-tab-item>-->
    <!--</mt-navbar>-->
    <!--<div style="height:7.5vh;"></div>-->
    <!--</div>-->
    <div class="loadmore-container">
      <mt-loadmore :top-method="loadTop" ref="loadmore" v-infinite-scroll="scroll_load" :infinite-scroll-disabled="loading" infinite-scroll-distance="1">
        <div v-for="(item,index) in list" :key='index' class="bg_white c_p_10 c_m_t_10" @click="todetails(item)">
          <div class="c_nowrap c_blue">订单编号： {{item.vbillcode}}</div>
          <div class="c_nowrap c_p_t_10">工程编号： {{item.servicecode}}</div>
          <div class="c_nowrap c_p_t_10">套餐名称： {{item.product}}</div>
          <!--<div class="c_nowrap c_p_t_10">订单状态： {{item.state ==0?'未开始':'进行中'}}</div>-->
          <div class="c_nowrap c_p_t_10">客户姓名： {{item.name}}</div>
          <div class="c_nowrap c_p_t_10" v-show="item.phone">联系方式： {{item.phone}}</div>
          <div class="c_nowrap c_p_t_10">创建时间： {{item.createtime | getDatetime}}</div>
          <div class="c_nowrap c_p_t_10">订单金额： <span class="c_red">¥ {{item.totalmny}} &nbsp;</span>
            <!--<span class="c_size_10 c_black" v-if='!item.paystate'>(<span class="c_red">未支付</span>)</span>-->
            <!--<span class="c_size_10 c_black" v-if='item.paystate==1'>(<span class="c_blue_dark">部分支付</span>)</span>-->
            <!--<span class="c_size_10 c_black" v-if='item.paystate>=2'>(<span class="c_black">全部支付</span>)</span>-->
          </div>
        </div>
        <div class="c_size_10 c_gray c_p_10 c_center c_flex c_flex_center" v-show="list.length<1 &&(!showLoading)">
          <div class="c_gray">您还没有订单</div>
        </div>
        <div class="c_size_10 c_gray c_p_10 c_center c_flex c_flex_center" v-show="showLoading">
          <mt-spinner type="snake" color="#00ccff" :size="20" v-show="!stopload"></mt-spinner>
          <span v-show="stopload">已经是最后一页了</span>
        </div>
      </mt-loadmore>
    </div>
  </div>
</template>

<script>
  export default {
    name: "reportOrder",
    data:function () {
      return {
        serviceid:"", //有则进行筛选
        list:[],
        allLoaded:false,
        params:{
          pageIndex:0,
          pageSize:5,
          totalPages:1,
          bottomDropText:'释放加载',
        },
        // 无限滚动
        loading:false,
        showLoading:false,
        stopload:false,
      }
    },
    mounted:function(){
      this.$indicator.close();
      // this.loadList();
      var serviceid = this.$route.query.serviceid||'';
      if(serviceid){
        this.serviceid = serviceid;
      }
    },
    methods:{
      loadList:function(fun){
        this.$indicator.open();
        var $that = this;
        this.$ajax.get(this.$$api.mobile.getOrderList,{
          'pageIndex':$that.params.pageIndex,
          'pageSize':$that.params.pageSize,
          'sortField':'ts',
          'sortDirection':'desc',
          'search_state':1,
          search_serviceid:this.serviceid||'',
        },function (res) {
          if (res.status == 200) {
            var msg = res.data.detailMsg.data;
            var pageIndex = msg.number;
            var totalPages = msg.totalPages;
            if(pageIndex==0){
              $that.list = msg.content||[];
            }else if(pageIndex < totalPages){
              $that.list = $that.list.concat(msg.content);
            }
            $that.params.pageIndex = pageIndex+1;
            $that.params.totalPages = totalPages;
          }
          if(fun)fun();
          $that.$indicator.close();
        });
      },
      loadTop:function(){
        var $that = this;
        this.params.bottomDropText = '释放加载';
        this.params.pageIndex = 0;
        this.loadList(function () {
          setTimeout(function () {
            $that.$refs.loadmore.onTopLoaded();
          })
        });
      },
      loadBottom:function(){
        var pageIndex = this.params.pageIndex +1;
        var totalPages = this.params.totalPages;
        var $that = this;
        if(pageIndex < totalPages){
          this.params.pageIndex = pageIndex;
          this.loadList(function () {
            setTimeout(function () {
              $that.$refs.loadmore.onBottomLoaded();
            });
          });
        }else{
          //已经全部请求
          this.params.bottomDropText = '已经最后一页了';
          $that.$refs.loadmore.onBottomLoaded();
        }
      },
      todetails:function(msg){
        var id = msg.billid;
        var state = msg.state;
        if(!id)return;
        this.$router.push({path:'/orderDetail?id='+id+'&state='+state });
      },
      scroll_load:function () {
        // debugger
        if(this.loading){
          return;
        }
        this.loading = true;
        this.showLoading = true;
        var $that = this;
        var pageIndex = $that.params.pageIndex;
        var totalPages = $that.params.totalPages;
        if(pageIndex >= totalPages){
          // 已经到最后一页了
          this.stopload = true;
          setTimeout(function () {
            $that.showLoading = false;
            $that.loading = false;
          },2500);
        }else{
          this.stopload = false;
          $that.loadList(function () {
            $that.showLoading = false;
            $that.loading = false;
          });
        }
      },
    },
    watch:{
      $route:function (to,from) {
        this.serviceid = to.query.serviceid;
        this.loadList();
      }
    },
  }
</script>

<style scoped>
  .container{
    background: #f7f7f7;
    font-size: 4vw;
  }

</style>



// WEBPACK FOOTER //
// src/components/reportOrder.vue